module.exports = __webpack_public_path__ + "static/assets/e87a109f5101fa65c806d53d8e6fc361.png";